import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LocaleService} from '../../../../../micromate-learn-lib/src/lib/services/locale/locale.service';
import {BrandingService} from '../../../../../micromate-learn-lib/src/lib/services/branding/branding.service';

@Component({
    selector: 'app-slack-failure',
    templateUrl: './slack-failure.component.html',
    styleUrls: ['./slack-failure.component.scss'],
    standalone: false
})
export class SlackFailureComponent implements OnInit {

    constructor(
        private localeService: LocaleService,
        private translate: TranslateService,
        public brandingService: BrandingService
    ) {}

    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    public async ngOnInit(): Promise<void> {
        this.brandingService.setTaskbaseBranding();
        const bestMatchingLocale = await this.localeService.getBestMatching(navigator.language);
        this.translate.use(bestMatchingLocale.supported);
    }

    public openHelp = async (): Promise<void> => {
        window.open('https://taskbase.atlassian.net/wiki/spaces/Micromate/pages/1537839415/Taskbase+Slack+App+Installation#Troubleshooting', '_blank');
        return Promise.resolve();
    }
}
